import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const FastForwardFifteenIcon: FunctionComponent<FastForwardFifteenIconProps> = ({
  size = 42,
  backgroundFillColor,
  textFillColor,
}) => {
  const { colors } = useTheme()
  const backgroundColor = backgroundFillColor ? backgroundFillColor : colors.backgroundSection
  const textColor = textFillColor ? textFillColor : colors.backgroundActive

  return (
    <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
      <Rect width='42' height='42' rx='21' fill={backgroundColor} />
      <Path
        d='M20.9707 10C16.7618 10 13.1428 12.4824 11.4633 16.0605C11.1704 16.6845 11.5323 17.395 12.1871 17.6105C12.8408 17.8256 13.5368 17.4638 13.8515 16.8518C15.1787 14.2704 17.8716 12.5 20.9707 12.5C22.9307 12.5 24.7007 13.22 26.0907 14.38L24.3243 16.1464C24.0093 16.4614 24.2324 17 24.6778 17H29.9707C30.2468 17 30.4707 16.7761 30.4707 16.5V11.2071C30.4707 10.7617 29.9321 10.5386 29.6171 10.8536L27.8707 12.6C26.0207 11 23.6207 10 20.9707 10Z'
        fill={textColor}
      />
      <Path
        d='M16.072 30V23.312H13.832V21.632H14.872C15.944 21.632 16.296 21.04 16.296 20.24V19.76H18.184V30H16.072ZM24.431 23.328C26.431 23.328 27.727 24.768 27.727 26.688C27.727 28.832 26.079 30.16 23.871 30.16C21.759 30.16 20.319 28.944 20.207 26.944H22.239C22.319 27.92 22.975 28.496 23.903 28.496C24.927 28.496 25.631 27.824 25.631 26.736C25.631 25.68 25.007 24.88 23.951 24.88C23.247 24.88 22.655 25.2 22.335 25.76L20.447 25.344L20.991 19.76H27.247V21.472H22.799L22.527 23.92C22.895 23.616 23.519 23.328 24.431 23.328Z'
        fill={textColor}
      />
    </Svg>
  )
}

type FastForwardFifteenIconProps = {
  size?: string | number
  backgroundFillColor?: string
  textFillColor?: string
}
